import { render, staticRenderFns } from "./AppPlayer.vue?vue&type=template&id=912dc366&scoped=true"
import script from "./AppPlayer.vue?vue&type=script&lang=js"
export * from "./AppPlayer.vue?vue&type=script&lang=js"
import style0 from "./AppPlayer.vue?vue&type=style&index=0&id=912dc366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912dc366",
  null
  
)

export default component.exports